import React, {Component} from 'react'
import {QuizzSlidesStyle} from './../../../../styles'
import {Checkbox, Button, Valid} from './../../../../components'
import { fetchQuestion, addQuiz } from '../../../../services/ApiController'
import DEFAULT_IMG from '../../../../static/default_picture_RM_quizz.png'

export default class Intro extends Component {

  state = {
    question: {},
    response: {},
    time: 0,
    initTime: 0,
    ready: false,
    data: {
      hash: '',
      answers: [],
    },
    good: [],
    explanation: '',
    valid: false,
    nextStep: false,
    disabled: false,
    last: false,
  }

  componentDidMount () {
    this.getQuestion()
  }
  
  componentWillUnmount() {
    clearInterval(this.timer_quiz)
    clearInterval(this.timer)
  }

  componentWillReceiveProps({data}){
    if (data !== this.props.data){
    }
  }


  tick () {
    if(this.state.time > 0){
      this.setState({
        time : this.state.time - 1
      })
    }else{
      this.submitQuizz()
    }
  }

  handlerChecked = (data) => {
    let nAnswers = this.state.data.answers
    if (data.checked) nAnswers.push(data.value)
    else nAnswers = nAnswers.filter( answer => answer !== data.value)
    
    this.setState({ data: {
      hash: this.state.data.hash,
      answers: nAnswers,
    }})
  }

  getQuestion = async () => {
    clearTimeout(this.timerNextQuestion)
    clearTimeout(this.timerNextStep)

    await fetchQuestion(this.props.id).then((data) => {
      console.log(data)
      if(data.state !== 'score') {
        this.setState({
          question: data,
          time: data.time_left,
          initTime: data.time_left,
          ready: true,
          last: data.position_question === data.total_questions,
          data: {
            hash: data.hash,
            answers: [],
          }
        })
      } else {
        this.props.getFinal(data)
      }

      return data.state
    }).then((state) => {
      if(state !== 'score') {
        this.timer_quiz = setInterval(
          () => this.tick(),
          1000
        )
      }
    }).catch((e) => {
      console.log('Ooops something wrong with Question')
    })
  }

  submitQuizz = async () => {
    if (this.state.data.answers.length === 0 )  {
      this.setState({ data: {
        hash: this.state.data.hash,
        answers: ["-1"]
      }}, () => {
        this.submitQuizzHandler()
      })
    } else {
      this.submitQuizzHandler()
    }
  }

  submitQuizzHandler = async () => {
    const url = this.props.current ? `/challenge/quiz/question.json` : `/challenge/quiz/${this.props.id}/question.json`

    clearInterval(this.timer_quiz)

    await addQuiz(url, this.state.data).then((data) => {
      this.setState({
        good: data.good_answers,
        explanation: data.explanation,
        valid: data.valid,
        nextStep: data.valid,
        disabled: !data.valid,
      })
    }).then(() => {
      if (this.props.current) {
        this.nextQuestion()
      } else {
        if (this.state.question.current) {
          this.nextQuestion()      
        } else {   
          this.timerNextStep = setTimeout(() => {
            this.setState({ nextStep: true })
          }, 3000)
        }
      }
    }).catch((e) => {
      console.log('Something wrong with fetching question', e)
    })
  }

  nextQuestion = async () => {
    this.setState({ ready: false })
    this.timerNextQuestion = setTimeout(() => {
      this.setState({
        question: {},
        response: {},
        time: 0,
        initTime: 0,
        ready: false,
        data: {
          hash: '',
          answers: [],
        },
        good: [],
        explanation: '',
        valid: false,
        nextStep: false,
        disabled: false,
      }, async () => {
        await this.getQuestion()
      })
    }, 300)
  }

  render () {
    const {
      question, 
      time, 
      ready, 
      explanation, 
      good, 
      valid, 
      initTime, 
      nextStep, 
      disabled, 
      data,
      last
    } = this.state
    return (
      <div className={` quizz ${QuizzSlidesStyle(question.image ? question.image : DEFAULT_IMG, initTime, ready, nextStep, question.image ? 'cover' : 'contain')}`}>
        <div className='quizz-container flex'>
          <div className='quizz-picture'></div>
          <div className='quizz-question'>
            <form onSubmit={this.submitQuizz}>
              <div className='quizz-pagination flex'>
                <span className='quizz-pagination-active'> { question.position_question } </span>
                <span className='quizz-pagination-total'> { question.total_questions} </span>
              </div>
              <div className='quizz-category'>
                {question.category_question}
              </div>
              
              <div className='quizz-title'>
                { question.position_question }. {question.question}
              </div>
              {
                !(nextStep && !valid) && (
                  <div className='quizz-first-step'>
                    <div className={`quizz-choices ${this.props.current ? 'quizz-choices--current' : ''}`}>
                      {
                        question.choices && question.choices.length > 0 && question.choices.map((choice) => (
                          <Checkbox 
                           
                            className={`
                              ${!question.current && good.length > 0 && data.answers.indexOf(choice.id.toString()) !== -1 && good.indexOf(choice.id) !== -1 && 'good'} 
                              ${!question.current && good.length > 0 && data.answers.indexOf(choice.id.toString()) !== -1 && good.indexOf(choice.id) === -1 && 'bad'} 
                              ${!question.current && good.length > 0 && data.answers.indexOf(choice.id.toString()) === -1 && good.indexOf(choice.id) !== -1 && 'valid'}`
                            }
                          onCallback={this.handlerChecked} key={choice.id} name={`${question.question}[${choice.id}]`} id={`${question.question}[${choice.id}]`} value={choice.id} > 
                            {choice.value} 
                            <Valid width={16} height={16} />
                          </Checkbox>
                        ))
                      }
                    </div>
                  </div>
                )
              }

              {
                nextStep && !valid && !question.current && (
                  <div className='quizz-explanation' dangerouslySetInnerHTML={{'__html': explanation}} />
                )
              }

              {
                disabled || !nextStep && (
                  <div className='quizz-valid flex items-center'>
                    <div className='quizz-timer flex items-center'>
                      <div className='timer'>
                        <div className='timer-progress'></div>
                      </div>
                      <span className="time">{time}s</span>
                    </div>
                    <Button type="submit" theme="red" onCallback={this.submitQuizz} > Validate </Button>
                  </div>
                )
              }

              {
                nextStep && (
                  <div className="btn-next-question ">
                    <Button type="button" onCallback={this.nextQuestion} > { last ? 'Result' : 'Next'} </Button> 
                  </div>
                )
              }
            </form>
           </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Quizz/Slides.js